import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetCmsasizepDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CMSA_SIZEP_DETAILS, token);
  return res;
};

export const AddCmsasizep = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_CMSA_SIZEP, payload, token);
  return res;
};

export const UpdateCmsasizep = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.UPDATE_CMSA_SIZEP + payload.id,
    payload,
    token
  );
  return res;
};

export const DeleteCmsasizep = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_CMSA_SIZEP + id, id, token);
  return res;
};

export const GetCBSA = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CBSA, token);
  return res;
};
